var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"overflow-hidden",attrs:{"elevation":"10","rounded":""}},[_c('v-card-text',{staticClass:"pa-8"},[_c('customers-table')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }